import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "login-page",
  class: "relative mx-auto h-full w-full max-w-screen-md p-8 md:p-0"
}
const _hoisted_2 = { class: "pt-32 mx-auto max-w-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_form, {
        ref: "form",
        class: "elevation-6 p-4 rounded-md white",
        "lazy-validation": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            modelValue: _ctx.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
            autocomplete: "false",
            class: "mb-2",
            label: "E-mail",
            required: "",
            variant: "outlined",
            rules: _ctx.emailRules
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(_component_v_text_field, {
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
            autocomplete: "false",
            class: "mb-4",
            label: "Password",
            required: "",
            variant: "outlined",
            rules: [_ctx.required, _ctx.min8],
            type: "password"
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(_component_v_text_field, {
            modelValue: _ctx.confirmPassword,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirmPassword) = $event)),
            autocomplete: "false",
            class: "mb-4",
            label: "Confirm password",
            required: "",
            variant: "outlined",
            rules: [_ctx.required, _ctx.min8, _ctx.matchingPasswords],
            type: "password"
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(_component_v_btn, {
            disabled: !_ctx.email,
            color: "primary",
            onClick: _ctx.resetPassword
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode(" Reset password ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _: 1
      }, 512)
    ]),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.successState,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.successState) = $event)),
      timeout: "3000"
    }, {
      action: _withCtx(({ attrs }) => [
        _createVNode(_component_v_btn, _mergeProps({
          color: "white",
          text: ""
        }, attrs, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.successState = false))
        }), {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode(" Close ", -1)
          ]))]),
          _: 1
        }, 16)
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.successStateText) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.errorState,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.errorState) = $event)),
      color: "error",
      timeout: "3000"
    }, {
      action: _withCtx(({ attrs }) => [
        _createVNode(_component_v_btn, _mergeProps({
          color: "white",
          text: ""
        }, attrs, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.errorState = false))
        }), {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createTextVNode(" Close ", -1)
          ]))]),
          _: 1
        }, 16)
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.errorStateText) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}